import React from 'react';
import SmsSegmentCounter from './SmsSegmentCounter';
import { analyze, normalize } from '../utils/smsSegments';

// The text part of the Email Customers compose step: no subject, a text box
// with the live segment counter, a "Convert smart quotes" button for text
// pasted from a word processor, and the merge-field chips.
//
// The server appends " Reply STOP to opt out." to every text that does not
// already say STOP (services/smsSend.js composeBody), and merges
// {{snow_price}} onto one line. Both are said here so the counter's number is
// not a surprise on the preview.
function SmsCompose({ body, onChange, mergeFields }) {
  const converted = normalize(body || '');
  const canConvert = converted !== (body || '');
  const stillUcs2 = analyze(converted).encoding === 'UCS-2';
  const saysStop = /\bSTOP\b/i.test(body || '');

  return (
    <div>
      <div className="form-group">
        <label className="form-label" htmlFor="sms-compose-body">Text message</label>
        <textarea
          id="sms-compose-body"
          className="form-textarea"
          value={body}
          onChange={(e) => onChange(e.target.value)}
          rows={5}
          placeholder="Write your text here..."
          style={{ fontFamily: 'inherit', lineHeight: '1.5' }}
        />
        <SmsSegmentCounter text={body} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <button
            type="button"
            className="btn btn-sm btn-outline"
            onClick={() => onChange(converted)}
            disabled={!canConvert}
          >
            Convert smart quotes
          </button>
          {canConvert && (
            <span style={{ fontSize: '12px', color: 'var(--color-text-light)' }}>
              {stillUcs2
                ? 'Converting helps, but other characters still need UCS-2.'
                : 'Converting brings this text back to GSM-7.'}
            </span>
          )}
        </div>
        <div style={{ fontSize: '12px', color: 'var(--color-text-light)', marginTop: '6px' }}>
          {saysStop
            ? 'Your text mentions STOP, so nothing is added to it.'
            : '"Reply STOP to opt out." is added to the end of every text.'}
          {' '}Merge fields are counted as typed; the preview shows the real length.
        </div>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '4px' }}>
        <span style={{ fontSize: '12px', color: 'var(--color-text-light)', lineHeight: '28px' }}>Insert:</span>
        {mergeFields.map((field) => (
          <button
            key={field}
            type="button"
            className="btn btn-sm btn-outline"
            style={{ fontSize: '11px', padding: '2px 8px' }}
            onClick={() => onChange(`${body || ''}{{${field}}}`)}
            aria-label={`Insert ${field} into the text`}
          >
            {`{{${field}}}`}
          </button>
        ))}
      </div>
      {/\{\{snow_price\}\}/i.test(body || '') && (
        <div style={{ fontSize: '12px', color: 'var(--color-text-light)', marginTop: '6px' }}>
          In a text, {'{{snow_price}}'} is joined onto a single line ("Up to 4 in: $45, 4 to 8 in: $60").
        </div>
      )}
    </div>
  );
}

export default SmsCompose;
